import { createAction, props } from '@ngrx/store';
import {
  CreateUpdateRFIModel,
  RFI,
  RFIAnswerStatus,
  RFIFilterParams,
  RFIListingItem,
  UpdateRFIModel,
} from '@app/store/rfis/rfi.types';

const onOpenRFIListing = createAction('[RFI] Open RFI Listing', props<{ projectId: number }>());
const loadRFIs = createAction('[RFI] Load RFIs', props<{ projectId: number }>());
const loadRFIsSuccess = createAction(
  '[RFI] Load RFIs Success',
  props<{ rfis: RFIListingItem[]; filters: RFIFilterParams }>(),
);
const loadRFIsFailure = createAction('[RFI] Load RFIs Failure', props<{ error: string }>());

const onCreateRFISidebarOpened = createAction(
  '[RFI] Create RFI Sidebar Opened',
  props<{ projectId: number }>(),
);

const onCreateRFI = createAction(
  '[RFI] Create RFI',
  props<{ data: CreateUpdateRFIModel; closeSidebar: boolean }>(),
);
const createRFISuccess = createAction('[RFI] Create RFI Success', props<{ rfi: RFI }>());
const createRFIFailure = createAction('[RFI] Create RFI Failure', props<{ error: string }>());

const updateRFI = createAction(
  '[RFI] Update RFI',
  props<{
    rfiId: number;
    rfi: Partial<UpdateRFIModel>;
    filesToDelete: number[];
    closeSidebar?: boolean;
  }>(),
);
const updateRFISuccess = createAction('[RFI] Update RFI Success', props<{ rfi: RFI }>());
const updateRFIFailure = createAction(
  '[RFI] Update RFI Failure',
  props<{ rfiId: number; error: string }>(),
);
const updateRFIResponsibleSeenStatusSuccess = createAction(
  '[RFI] Update RFI Responsible Seen Status Success',
  props<{ rfi: RFI }>(),
);
const updateRFIResponsibleSeenStatusFailure = createAction(
  '[RFI] Update RFI Responsible Seen Status Failure',
  props<{ rfiId: number; error: string }>(),
);

const deleteRFI = createAction('[RFI] Delete RFI', props<{ rfiId: number }>());
const deleteRFISuccess = createAction('[RFI] Delete RFI Success', props<{ rfiId: number }>());
const deleteRFIFailure = createAction(
  '[RFI] Delete RFI Failure',
  props<{ rfiId: number; error: string }>(),
);

const onOpenRFIDetails = createAction('[RFI] Open RFI details', props<{ rfiId: number | null }>());
const loadRFIDetailsSuccess = createAction('[RFI] Load RFI Details Success', props<{ rfi: RFI }>());
const loadRFIDetailsFailure = createAction(
  '[RFI] Load RFI Details Failure',
  props<{ error: string }>(),
);
const saveAnswer = createAction(
  '[RFI] Save Answer',
  props<{
    answerText: string;
    status: RFIAnswerStatus;
    filesToDelete: number[];
    rfiId: number;
  }>(),
);
const saveQuestion = createAction(
  '[RFI] Save Question',
  props<{
    questionText: string;
    rfiId: number;
    filesToDelete: number[];
  }>(),
);
const approveAnswer = createAction('[RFI] Approve Answer', props<{ rfiId: number }>());
const markRFIOpen = createAction('[RFI] Mark RFI as Open', props<{ rfiId: number }>());
const closeRFI = createAction('[RFI] Close RFI', props<{ rfiId: number }>());
const reOpenRFI = createAction('[RFI] Re-Open RFI', props<{ rfiId: number }>());
const voidRFI = createAction('[RFI] Void RFI', props<{ rfiId: number }>());

const loadRFINumberSuccess = createAction(
  '[RFI] Load RFI Number Success',
  props<{ rfiNumber: string }>(),
);

const filtersChanged = createAction(
  '[RFI] Filters changed',
  props<{ projectId: number; filters: Partial<RFIFilterParams> }>(),
);
const loadNextPage = createAction('[RFI] Load Next Page', props<{ projectId: number }>());

const onProjectViewClosed = createAction('[RFI] Clear RFIs');
const cancel = createAction('[RFI] Cancel');

export const RFIActions = {
  onOpenRFIListing,
  loadRFIs,
  loadNextPage,
  loadRFIsSuccess,
  loadRFIsFailure,

  onCreateRFISidebarOpened,
  onCreateRFI,
  createRFISuccess,
  createRFIFailure,

  updateRFI,
  updateRFISuccess,
  updateRFIFailure,
  updateRFIResponsibleSeenStatusSuccess,
  updateRFIResponsibleSeenStatusFailure,

  deleteRFI,
  deleteRFISuccess,
  deleteRFIFailure,

  onOpenRFIDetails,
  loadRFIDetailsSuccess,
  loadRFIDetailsFailure,

  saveAnswer,
  saveQuestion,
  approveAnswer,
  markRFIOpen,
  closeRFI,
  reOpenRFI,
  voidRFI,

  loadRFINumberSuccess,
  filtersChanged,

  onProjectViewClosed,
  cancel,
};
